import React, { useEffect, useState } from "react";

import "./Report.css";
import "../../Components/Commons/Commons.css";

import SidebarMenu from "../../Components/Sidebar/Sidebar";
import BtnExcel from "../../Components/Commons/Buttons/BtnExcel";
import dayjs from "dayjs";
import BtnDownloadTable from "../../Components/Commons/Buttons/BtnDownloadTable";
import { getOutpatientVisits } from "../../Components/Helpers/API/ReportsApi/ReportsApi";
import { Table } from "antd";
import { formatDate } from "../../Assets/Helpers/Common";
import {
  formatDateWithTime,
  formatPrice,
  getTodayDateISO,
} from "../../Components/Helpers/Utilities/Common";

function OutpatientVisits() {
  const [showLoader, setShowLoader] = useState(false);
  const [totalProfessionalFee, setTotalProfessionalFee] = useState("");
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [residents, setResidents] = useState([]);
  const [dateRange, setDateRange] = useState([
    dayjs(getTodayDateISO(), "YYYY-MM-DD"),
    dayjs(getTodayDateISO(), "YYYY-MM-DD"),
  ]);
  const [data, setData] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const xlsxHeaders = ["Outpatient", "Number"];


  //Function for adding a custom footer in the table
  const customFooter = () => (
    <div style={{ textAlign: "center" }}>
      Total: {totalProfessionalFee ? formatPrice(totalProfessionalFee) : "0"}
    </div>
  );

  const columns = [
  {
    title: "Outpatient",
    dataIndex: "label",
    key: "label",
    render: text => <b>{text}</b>,
  },
  {
    title: "Number",
    dataIndex: "value",
    key: "value",
    align: "right",
  },
];

  //Function for handling the date range in the table
  const onDateChange = (date,dateString) => {
    setDateRange(dateString);
  };

  //Function for handling the doctor filter in the table
  const handleDoctorChange = (value) => {
    setSelectedDoctor(value);
  };

  //Function for getting pdf header
  const getPdfHeaderTitle = () => {
    if (dateRange[0] && dateRange[1]) {
      var from = formatDate(dateRange[0]);
      var to = formatDate(dateRange[1]);

      return from !== to ? `${from} - ${to}` : from;
    } else {
      return formatDate(getTodayDateISO());
    }
  };

  //Funcion get daily log report API
  async function _get() {
    setShowLoader(true);
    const res = await getOutpatientVisits();
    if (res.data) {
    const visits = res.data;
    const newReportData = [
      {
        key: "new_patient",
        label: "Number of outpatient visits, new patient",
        value: visits.new_patient || 0,
      },
      {
        key: "re_visit",
        label: "Number of outpatient visits, re-visits",
        value: visits.re_visit || 0,
      },
      {
        key: "adult",
        label: "Number of outpatient visits, adult (Age 14 yrs. old and above)",
        value: visits.adult || 0,
      },
      {
        key: "pediatric",
        label: "Number of outpatient visits, pediatric (Age 13 yrs. old and below)",
        value: visits.pediatric || 0,
      },
      {
        key: "adult_genmed",
        label: "Number of adult general medicine outpatient visits",
        value: visits.adult_genmed || 0,
      },
      {
        key: "non_surgical",
        label: "Number of specialty (non-surgical) outpatient visits",
        value: visits.non_surgical || 0,
      },
      {
        key: "surgical",
        label: "Number of surgical outpatient visits",
        value: visits.surgical || 0,
      },
    ];
      setData(newReportData)
      const excelFormattedData = newReportData.map(item => ({
        "Outpatient": item.label,
        "Number": parseInt(item.value),
      }));
      setExcelData(excelFormattedData);
    } else if (res.error) {
      setData([]);
      setExcelData([]);
    }
    setShowLoader(false);
  }

  useEffect(() => {
    _get();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      <SidebarMenu active={"Reports"} active_sub={"Outpatient Visits"} />
      <div className="col p-5 pt-4 scrollable-container">
        <div className="row pt-3">
          <div className="col font-big title-2 all-patient">
            Outpatient Visits
          </div>
          <div className="col-2 flex patient-manager">
            <BtnDownloadTable
              label={"Download PDF"}
              size={"sm"}
              data={{
                body: data,
                columns: [
                  { header: "Outpatient", dataKey: "label" },
                  { header: "Number", dataKey: "value" },
                ],
              }}
              fileName={`${getTodayDateISO()} Outpatient Visits.pdf`}
              pdfHeader={{
                title: `Outpatient Visits Report (${getPdfHeaderTitle()})`,
                content: `This report is generated on ${formatDateWithTime(
                  new Date()
                )}.`,
              }}
              pdfFooter={false}
            />
          </div>
          <div className="col-2 fles patient-manager">
            <BtnExcel
              label={"Download Excel"}
              size={"sm"}
              excelData={excelData}
              xlsxHeaders={xlsxHeaders}
              fileName={"OutpatientVisits.xlsx"}
            />
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-sm-12 all-table px-3 pt-3" id="antd-table-container">
            <Table
                columns={columns}
                dataSource={data}
                pagination={false}
                bordered
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default OutpatientVisits;
